module.exports = __webpack_public_path__ + "static/img/banner2.a3568a2.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/banner2.png
// module id = NmU9
// module chunks = 1